<template lang="html">

  <section class="users">
    <div class="pageHeading">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs8 md6>
            <h2>Businesses</h2>
          </v-flex>
          <v-flex md6>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-layout column style="padding-top:16px">
      <v-data-table hide-actions :headers="headers" :items="businesses" :search="search"
                    :hide-headers="isMobile" :class="{mobile: isMobile}"
      >
        <template slot="items" slot-scope="props">
          <tr @click="$router.push('/UpdateBusiness/'+props.item._id)" style="cursor: pointer">
            <td>
              <span v-if="$feathers.get('user').businesses.includes(props.item._id)" style="color: green; font-weight: bold">{{ props.item.name }}</span>
              <span v-else>{{ props.item.name }}</span>
            </td>
            <td class="text-xs-left">{{ props.item.address }}</td>
            <td class="text-xs-left">{{ props.item.notes }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-layout>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'businesses',
    props: [],
    mounted() {
        var vueThis = this;

        this.$services.businesses.find().then((result) => {
            vueThis.businesses = result.data
            console.log('biz list is', result)
        })
    },
    data() {
      return {
          businesses: [],
          selected: [],
          search: '',
          isMobile: false,
          headers: [
              {
                  text: 'Business Or School Name',
                  align: 'left',
                  sortable: true,
                  value: 'name',
                  width: '30%'
              },
              { text: 'Address',
                  align: 'left',
                  sortable: false,
                  width: '30%',
                  value: 'address' },

              { text: 'Notes',
                  align: 'left',
                  width: '30%',
                  sortable: false,
                  value: 'notes' }
          ]
      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .businesses {

  }
</style>
